export default {
	title: "",
	subtitle: "Cancel a Subscription",
  path: "subscription_cancel",
  paragraph: 'With this endpoint, you can cancel an active subscription by providing its unique ID. Once canceled, the subscription will no longer generate future invoices or charges.',
  request: {
    method: "PUT",
		endpoint: "/subscriptions/:id/cancel",
    payload: {
      "reason": "some reason"
    },
		responses: {
      "data": {
        "canceled_at": "2025-09-17T14:50:41.026777Z",
        "canceled_by_payer": false,
        "canceled_reason": "some reason",
        "completed_at": null,
        "currency": "BRL",
        "cycles": 12,
        "description": "some description",
        "free_days": 0,
        "frequency": "month",
        "from_bank_account_id": null,
        "id": "3b6f32b7-ba43-4038-8c0b-3078069754d9",
        "inserted_at": "2025-09-19T14:50:40.919497",
        "payer_bank_account_id": null,
        "payer_card_id": "c4aaddcd-875c-4cd0-993a-098da28baa4d",
        "payment_method": "card",
        "status": "canceled",
        "subject_id": "f7f25961-4e68-473c-9579-67c529307835",
        "to_bank_account_id": "7055d7b0-9126-4a9a-b5d8-290de368f1a5",
        "total_retry_attempts": 0,
        "trial_days": 0,
        "updated_at": "2025-09-19T14:50:41.026830",
        "value": "100"
      }
    }
	},
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Subscription ID"
    }
  ],
	parameterPayload: [
    {
      name: "reason",
      type: "string",
      required: true,
      description: "Reason for cancellation"
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionCancel.js